import React, { useRef } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import { errorNotification } from "Components/MyNotification";

const MyUploadWrapper = ({
  customRequest,
  btnText,
  multiple = false,
  customOnChange,
  resetOnSelect = false,
  disabled = false,
}) => {
  return (
    <MyUpload
      disabled={disabled}
      customRequest={customRequest}
      btnText={btnText}
      multiple={multiple}
      customOnChange={customOnChange}
      resetOnSelect={resetOnSelect}
    />
  );
};

const MyUpload = ({
  btnText = "",
  customRequest = () => {},
  multiple = false,
  customOnChange = () => {},
  resetOnSelect = false,
  disabled = false,
}) => {
  const timerRef = useRef();
  return (
    <>
      <Upload
        disabled={disabled}
        multiple={multiple}
        accept=".xls,.xlsx"
        beforeUpload={(file) => {
          const isExcel =
            file.type ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            file.type === "application/vnd.ms-excel";

          if (!isExcel) {
            errorNotification("Можна завантажувати лише Excel файли");
          }

          return isExcel || Upload.LIST_IGNORE;
        }}
        customRequest={({ file }) => customRequest(file)}
        showUploadList={false}
        onChange={({ fileList }) => {
          clearTimeout(timerRef.current);

          timerRef.current = setTimeout(() => {
            customOnChange(fileList);
            if (resetOnSelect) {
              fileList.length = 0;
            }
          }, 50);
        }}
      >
        <Button disabled={disabled} icon={<UploadOutlined />}>
          {btnText}
        </Button>
      </Upload>
    </>
  );
};
export { MyUpload, MyUploadWrapper };
